import React, { useContext } from "react";

// Material UI imports
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";

// components
import AddClassPropertiesTableCell from "./AddClassPropertiesTableCell";

// Global state
import { StateContext } from "../../AppStateContext.js";

// schema add class state
import { SchemaAddClassStateContext } from "./SchemaAddClassStateContext";

const AddClassPropertiesTable = () => {
  // To consume global state
  const state = useContext(StateContext);

  // schema state
  const schemaState = useContext(SchemaAddClassStateContext);

  return (
    <Table className="__addClassPropertyTable" aria-label="simple table">
      <TableBody style={{ zIndex: "0" }}>
        {schemaState.properties.length ? (
          schemaState.properties.map((prop, idx) => (
            <TableRow key={idx}>
              <AddClassPropertiesTableCell text={prop.name} align="left" />
              <AddClassPropertiesTableCell
                text={prop.description}
                align="center"
              />
              <AddClassPropertiesTableCell
                text={prop.dataType[0]}
                align="right"
              />
            </TableRow>
          ))
        ) : (
          <TableCell
            align="left"
            className={
              state.theme === "dark"
                ? "__addClassPropertyTableBodyCell __addClassPropertyTableBodyCellDark"
                : "__addClassPropertyTableBodyCell __addClassPropertyTableBodyCellLight"
            }
            style={{
              background: "transparent",
              height: "20px",
            }}
          >
            No properties yet
          </TableCell>
        )}
      </TableBody>
    </Table>
  );
};

export default AddClassPropertiesTable;
